import React, { useState } from 'react'
import styles from './styles.module.scss'
import ActionButton, { ActionButtonSize } from '../action-button/action-button'
import ActionCheckbox from '../action-checkbox/action-checkbox'

type SideInputElement = 'button' | 'checkbox' | 'svg'

interface BaseProps extends React.InputHTMLAttributes<HTMLInputElement> {
    /** Elemento que ficará dentro da caixa do input. */
    sideElement?: SideInputElement
    sideElementPosition?: 'left' | 'right'
    /** Ativa o efeito de loading caso o elemento ao lado seja um botão. */
    isButtonLoading?: boolean
    isRequired?: boolean
    classNameInput?: string
    classNameButton?: string
    classNameSvg?: string
    classNameContainer?: string
    onButtonClick?(): void
    onCheck?(): void
}

interface ButtonProps extends BaseProps {
    sideElement: 'button'
    sideElementPosition?: 'left' | 'right'
    titleButton: string
    buttonSize: ActionButtonSize
    svg?: never
    titleCheckbox?: never
}

interface CheckboxProps extends BaseProps {
    sideElement: 'checkbox'
    sideElementPosition?: 'left' | 'right'
    titleCheckbox?: string
    svg?: never
    titleButton?: never
    buttonSize?: never
    isButtonLoading?: never
    onButtonClick?(): never
}

interface SvgProps extends BaseProps {
    sideElement: 'svg'
    sideElementPosition?: 'left' | 'right'
    svg: React.JSX.Element
    titleButton?: never
    buttonSize?: never
    titleCheckbox?: never
    classNameButton?: never
    isButtonLoading?: never
    onButtonClick?: never
}

type Props =
    | (BaseProps & { sideElement?: undefined; svg?: never; titleButton?: never; buttonSize?: never, titleCheckbox?: never })
    | ButtonProps
    | CheckboxProps
    | SvgProps

/** Componente de input que segue o layout do MenuDino. */
export default function ActionInput(props: Props) {
    const {
        sideElement,
        sideElementPosition,
        isButtonLoading,
        isRequired,
        buttonSize,
        classNameInput,
        classNameButton,
        classNameSvg,
        classNameContainer,
        onButtonClick,
        onCheck,
        titleButton,
        titleCheckbox,
        svg,
        ...inputProps
    } = props

    const renderSideElement = () => {
        if (sideElement === 'button') {
            return (
                <ActionButton
                    onClick={onButtonClick}
                    size={buttonSize}
                    className={`${styles.btn} ${classNameButton ?? ''}`}
                    isLoading={isButtonLoading ?? false}
                >
                    {titleButton}
                </ActionButton>
            )
        } else if (sideElement === 'checkbox') {
            return (
                <ActionCheckbox
                    onClick={onCheck}
                    checked={props.checked ?? false}
                    title={titleCheckbox} />
            )
        } else if (sideElement === 'svg') {
            return (
                <div className={`${styles.svgIcon} ${classNameSvg ?? ''} ${sideElementPosition === 'left' ? styles.leftElement : ''}`}>
                    {svg}
                </div>
            )
        }
        return null
    }

    return (
        <div className={`${styles.container} ${classNameContainer ?? ''} ${isRequired === true && styles.redBorder} ${sideElementPosition === 'left' ? styles.leftElementContainer : ''}`}>
            <input
                className={`${styles.customInput} ${classNameInput ?? ''}`}
                disabled={props.checked}
                {...inputProps}
            />
            {renderSideElement()}
        </div>
    )
}
